'use client';
import { useQuery } from '@tanstack/react-query';
import { ErrorBoundary } from 'react-error-boundary';

import { AuthQueryOptions } from '@/api';
import { useAuthStore } from '@/stores/AuthStore';

import { ChallengeErrorFallback } from '../ErrorFallback';
import { PrizeCardAnimated } from './CardAnimated';
import { ChallengeHeaderAnimated } from './HeaderAnimated';

const ChallengeContent = () => {
  const isLogin = useAuthStore((state) => !!state.isLogin);

  const { data: localTourData } = useQuery({
    ...AuthQueryOptions['get:/wello/v2/auth/home-donation/event/local-tour'](),
    enabled: isLogin,
    select: ({ context }) => context,
  });

  const donationCount = localTourData?.donationCount ?? 0;

  return (
    <>
      <div id="challenge" className="relative top-[-68px]" aria-hidden="true" />
      <section
        className="flex w-full flex-col items-center gap-36 bg-Y-50 px-24 py-60"
        aria-labelledby="challenge-heading"
      >
        <ChallengeHeaderAnimated />

        <div
          className="flex w-full flex-col gap-12"
          role="list"
          aria-label="기부 지역 챌린지 경품 목록"
        >
          <PrizeCardAnimated
            regions={2}
            isCompleted={donationCount >= 2 && donationCount < 5}
          />
          <PrizeCardAnimated
            regions={5}
            isCompleted={donationCount >= 5 && donationCount < 7}
          />
          <PrizeCardAnimated
            regions={7}
            isCompleted={donationCount >= 7 && donationCount < 10}
          />
          <PrizeCardAnimated regions={10} isCompleted={donationCount >= 10} />
          <p className="pt-4 text-center font-600 text-Gray-550 typo-body4">
            *12월 중 공지사항을 통해 당첨자 발표
          </p>
        </div>
      </section>
    </>
  );
};

export const Challenge = () => {
  return (
    <ErrorBoundary FallbackComponent={ChallengeErrorFallback}>
      <ChallengeContent />
    </ErrorBoundary>
  );
};
